
export class SolicitudCpeCertificacionViewModel {
    public Id: number;
    public IdEstadoSolicitudCpe: number = 0;
    public IdEstadoSolicitudCpeDescripcion: string;
    public Codigo: string;
    public IdUsuarioCa: number | null;
    public FechaEmision: Date | null;
    public FechaRechazo: Date | null;
    public TwCertificacionCertificadoPrevioEx: CertificacionCpeViewModel;
}
export class CertificacionCpeViewModel {
    public IdCertPrevioEx: number;
    public IdDecision: number | null;
    public IdEstadoSolicitudCpe: number;
    public IdEstadoSolicitudCpeDescripcion: string;
    public Codigo: string;
    public CheckCumpleRequisitos: boolean | null;
    public CumpleRequisitos: string;
    public CheckInspeccionOficial: boolean | null;
    public InspeccionOficial: string;
    public CheckAnalisisOficial: boolean | null;
    public AnalisisOficial: string;
    public CheckExentoA: boolean | null;
    public CheckExentoB: boolean | null;
    public CheckExentoC: boolean | null;
    public CheckExentoD: boolean | null;
    public CheckExentoE: boolean | null;
    public CheckExentoF: boolean | null;
    public CheckExentoG: boolean | null;

    public CheckExentoEspecificacionesAyG: boolean | null;
    public EspecificacionesAyG: string;

    public OtraInformacionOficial: string;
    public LugarExpedicion: string;
    public DatosContacto: string;
    public Observaciones: string;
    public TwCheckExentoAOrgNocivoCollection: CheckExentoViewModel[];
    public TwCheckExentoBOrgNocivoCollection: CheckExentoViewModel[];
    public TwCheckExentoCOrgNocivoCollection: CheckExentoViewModel[];
    public TwCheckExentoDOrgNocivoCollection: CheckExentoViewModel[];
    public TwCheckExentoEOrgNocivoCollection: CheckExentoViewModel[];
    public TwCheckExentoFOrgNocivoCollection: CheckExentoViewModel[];
    public TwCheckExentoGOrgNocivoCollection: CheckExentoViewModel[];
}
export class CheckExentoViewModel {
    public Id: number;
    public IdCertPrevioEx: number;
    public IdOrganismoNocivo: number;
    public OrganismoNocivoDescripcion: string;
}






